import { IChat } from '../types/IChat'
import { Avatar, Card, CardBody, CardHeader, CardSubtitle, CardTitle } from '@progress/kendo-react-layout'
import ReactTimeago from 'react-timeago'
import { ChatApi } from '../redux/api/ChatApi'
import OnlineIndicator from './OnlineIndicator'
import { ChatIsUnRead } from '../util/ChatUtils'
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
TimeAgo.addDefaultLocale(en);

export const ChatListItem = (chat: IChat) => {
    const { data: userProfile } = ChatApi.useGetProfileQuery();

    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
    let name = chat.Staff_Header || chat.End_User;
    let initials = [...name.matchAll(rgx)] || [];
    //console.log('initials', initials)
    let letters = (
        (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
    ).toUpperCase();

    if (!userProfile || !chat)
        return <></>

    return (

        <Card orientation="horizontal" style={{ width: '100%' }} className={ChatIsUnRead(userProfile.Uid, chat) ? 'unread chat-item' : 'chat-item'}>
            <span className="dot"></span>
            <span title={chat.End_User} className='profile-wrapper'>
                <OnlineIndicator Uid={chat.EndUserContact_Id === userProfile?.Id ? chat.Staff_Uid : chat.EndUser_Uid} />
                {chat.EndUser_Profile_Path && chat.EndUser_Profile_Path?.indexOf('placeholder') > -1
                    ? <Avatar className='avatar' size='medium' type="text">
                        {letters}
                    </Avatar>
                    : <Avatar className='avatar' size='small' type="image">
                        <img
                            src={(chat.EndUserContact_Id === userProfile?.Id ? chat.Staff_Profile_Path : chat.EndUser_Profile_Path) ?? './images/placeholder.png'}
                            alt={`profile image`}
                        />
                    </Avatar>
                }
            </span>
            <div className="k-vbox">
                <CardHeader>
                    {/* {ChatIsUnRead(userProfile.Uid, chat) ? 'unread' : 'read'} */}
                    <CardTitle>{chat.EndUserContact_Id === userProfile?.Id ? chat.Staff_Name : chat.Staff_Header}</CardTitle>
                    <CardSubtitle style={{ fontSize: '14px' }}>
                        {/* <div>{chat.Last_Message_Date}</div>
                        <div>{chat.EndUser_Last_Read}</div>
                        <div>{chat.Staff_Last_Read}</div> */}
                        <div className='truncate' style={{ width: 200 }}>{chat.Last_Message_Contact_Id == userProfile?.Id ? 'You: ' : ''} {chat.Last_Message}</div>
                    </CardSubtitle>
                </CardHeader>
            </div>
            <div style={{ margin: 0, fontSize: "0.7em" }}>
                {chat.Last_Message_Date && <ReactTimeago date={new Date(chat.Last_Message_Date + 'Z')} minPeriod={60} />}
            </div>
        </Card>

    )
}
